import { appendTestableElementAttributes } from '@dreryk/react-components';

import { StyledIssuedInvoicesPanel } from './IssuedInvoicesPanel.styled';
import { IssuedInvoicesTable } from './table/IssuedInvoicesTable';

export const IssuedInvoicesPanel = (): JSX.Element => {
   return (
      <StyledIssuedInvoicesPanel {...appendTestableElementAttributes('issuedInvoicesPanel')}>
         <IssuedInvoicesTable />
      </StyledIssuedInvoicesPanel>
   );
};
